const planConfig = {
	features: {
		plane: false,
		grid: false,

		controls: false,

		graph: false,
	},

	init: {
		event: true,
		merge: true,
		companies: true,
		search: true,
		graph: true,

		camera: true,

		walls: true,
		floor: false,
		booths: true,
		places: true,

		source: true,
	},

	scene: {
		backgroundColor: 0x1d1d1f,
	},

	navigation: {
		speed: 200,

		cameraXOffset: 0,
		cameraYOffset: 300,
		cameraZOffset: 500,

		cameraResetDelay: 2000,
		cameraResetDuration: 2000,

		startDelay: 500,
		endDelay: 5000,
	},

	sponsorsScreen: {
		enabled: true,
		transition: 300,
		duration: 3000,
	},

	search: {
		animate: true,
		allowManual: true,
		label: true,
	},

	objects: {
		floor: {
			faceColor: 0x4a4a4a,
			extrusionColor: 0x4a4a4a,

			depth: 3,
			noTranslate: true,
		},
		walls: {
			faceColor: 0x888888,
			extrusionColor: 0x777777,

			depth: 50,
		},
		places: {
			faceColor: 0x666666,
			extrusionColor: 0xababab,

			depth: 20,
			bevel: {
				offset: -1,
				thickness: 2,
				segments: 1,
			},
		},
		booths: {
			faceColor: 0x999999,
			extrusionColor: 0xfafafa,

			depth: 20,
			bevel: {
				offset: -1,
				thickness: 2,
				segments: 1,
			},
		},
		paths: {
			booth: {
				faceColor: 0x0a84ff,
				extrusionColor: 0x0a84ff,

				width: 15,
				depth: 0.5,
			},
			place: {
				faceColor: 0x0a84ff,
				extrusionColor: 0x0a84ff,

				width: 15,
				depth: 0.5,
			},
		},

		marker: {
			scale: 2,
			yOffset: 0.5,

			inner: {
				faceColor: 0xffcc00,
				extrusionColor: 0xffcc00,

				scale: 0.8,
				yOffset: 0.5,

				depth: 0.25,
				bevel: {
					offset: -1,
					thickness: 1,
					segments: 10,
				},
			},
			outer: {
				faceColor: 0xffffff,
				extrusionColor: 0xffffff,

				depth: 0.5,
				bevel: {
					offset: -0.25,
					thickness: 0.35,
					segments: 10,
				},
			},
		},

		source: {
			height: 1,
			segments: 32,

			inner: {
				faceColor: 0x0a84ff,
				radius: 9,
			},
			outer: {
				faceColor: 0xffffff,
				radius: 12,
			},

			booth: {
				faceColor: 0x2aa4ff,
				extrusionColor: 0x2aa4ff,
			},
			place: {
				faceColor: 0x2aa4ff,
				extrusionColor: 0x2aa4ff,
			},
		},

		target: {
			booth: {
				faceColor: 0x0a84ff,
				extrusionColor: 0x0a84ff,
			},
			place: {
				faceColor: 0x0a84ff,
				extrusionColor: 0x0a84ff,
			},
		},
	},
};

export default planConfig;
